<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>
-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Task Monitor</a>
      </li>
    </ol>
    <div class="inner-wrapper">
      <div class="sub-wrapper">
        <h3 class="page-title obs-card-title">
          {{ "TASK.MONITORING_MATRIX" | translate }}
        </h3>
        <div class="section-wrapper">
          <div class="search-wrapper">
            <h5
              class="search-title"
              data-toggle="collapse"
              data-parent="#accordion"
              href="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <i class="fa fa-caret-down down" aria-hidden="true"></i
              ><i class="fa fa-caret-up up" aria-hidden="true"></i>
              {{ "TASK.SEARCH_CRITERIA" | translate }}
            </h5>
            <div
              id="collapseOne"
              class="panel-collapse collapse in"
              role="tabpanel"
              aria-labelledby="headingOne"
            >
              <div
                class="search-details-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12"
              >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div
                    style="padding: 10px"
                    class="col-md-2 col-sm-12 col-xs-12"
                  >
                    <div class="sub-section-wrapper">
                      <span class="section-sub-title">{{
                        "TASK.MONITORING_MATRIX" | translate
                      }}</span
                      ><br />
                      <p-multiSelect
                        [options]="monitoringMatrixNames"
                        placeholder="Select"
                        [(ngModel)]="selectedMatrix"
                        (onChange)="getSectionData()"
                        #matrixName="ngModel"
                        required
                      ></p-multiSelect>
                    </div>
                    <span
                      *ngIf="
                        matrixName.errors &&
                        (matrixName.dirty || matrixName.touched) &&
                        !matrixName.valid
                      "
                      class="section-Forerror"
                      style="margin-left: 0px; left: 0%"
                      >{{ "TASK.KINDLY SELECT MATRIX NAME" | translate }}
                    </span>
                  </div>
                  <div
                    style="padding: 10px"
                    class="col-md-2 col-sm-12 col-xs-12"
                  >
                    <div class="sub-section-wrapper">
                      <span class="section-sub-title"
                        >{{ "TASK.SECTION" | translate }} </span
                      ><br />
                      <p-multiSelect
                        [options]="SectionList"
                        [(ngModel)]="selectedStatus"
                      ></p-multiSelect>
                    </div>
                  </div>
                  <div
                    style="padding: 10px"
                    class="col-md-2 col-sm-12 col-xs-12"
                  >
                    <div class="sub-section-wrapper">
                      <span class="section-sub-title">{{
                        "TASK.VIEW_TYPE" | translate
                      }}</span
                      ><br />
                      <label
                        ><input
                          type="radio"
                          name="viewType"
                          value="daily"
                          text="Daily"
                          style="margin-right: 5px"
                          [(ngModel)]="viewType"
                        />Daily</label
                      >
                      <label
                        ><input
                          type="radio"
                          name="viewType"
                          value="monthly"
                          text="Monthly"
                          style="margin-right: 5px"
                          [(ngModel)]="viewType"
                        />Monthly</label
                      >
                    </div>
                  </div>
                  <div
                    style="padding: 10px"
                    class="col-md-2 col-sm-12 col-xs-12"
                  >
                    <!-- <footer class="no-margin-right"> -->
                    <div class="sub-section-wrapper">
                      <br />
                      <a
                        *ngIf="selectedStatus"
                        (click)="getMonitoringMatrixData()"
                        style="margin-right: 630px"
                        class="btn btn-primary button-excel"
                        role="button"
                        ><i class="fa fa-refresh"></i>Show Data</a
                      >
                    </div>
                    <!-- </footer> -->
                  </div>
                </div>
                <div class="clearfix"></div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 errror-desktopview"
                >
                  <p>
                    We request you use a web application to work with this
                    feature.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div id="chartdiv" [style.width.%]="100" [ngStyle]="{'height': dataCount +'px'}"></div>
        </div>
        <div class="clearfix"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div *ngIf="showLegend" class="sub-section-wrapper col-md-8">
            <span class="section-sub-title">Legend</span>
            <!-- <div id="legenddiv"></div> -->
            <div *ngFor="let legend of legend" class="legend">
              <div
                [ngStyle]="{ 'background-color': legend.color }"
                class="legend-color-box"
              ></div>
              <span class="legend-lebel">{{ legend.lebel }}</span>
            </div>
          </div>

          <a
            *ngIf="showZoomOutButton"
            (click)="ganttChart()"
            class="btn btn-primary primary-btn filter-sort"
            role="button"
            >Zoom Out</a
          >
        </div>
        <div class="clearfix"></div>
        <div class="breaker"></div>
        <footer>
          <a
            (click)="onClickBack()"
            class="btn btn-primary primary-btn button-float-left button-back"
            role="button"
            ><i class="fa fa-reply"></i>back to home</a
          >
          <a class="btn btn-primary primary-btn button-excelSpace" role="button"
            ><i class="fa fa-file-excel-o"></i>export to excel</a
          >
        </footer>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
